var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		abstract: true,
		'is-child-of-panel': this.parentBlock.name == 'qzrstudio/panel',
	}},[_c('div',{class:'font-size-25 color-' + _vm.pageColor,domProps:{"innerHTML":_vm._s(_vm.block.attrs.abstract)}}),_c('div',{staticClass:"abstract-background",class:{
			['background-' + _vm.pageColor + '-light']: true,
		}})])
}
var staticRenderFns = []

export { render, staticRenderFns }